import React from 'react';
import PropTypes from 'prop-types';
import { sanitizeString } from '../../../../../../ui-kitchen/src/utils/sanitizeString';
import './AmexShopSmallBanner.scss';

const AmexShopSmallBanner = ({
  matchMedia,
  baseRequestUrl,
  bannerConfig,
  eventTiming,
}) => {
  const {
    logo, photo_credit: photoCredit, retina_image: retinaImage, image,
  } = bannerConfig;

  const devicePixelRatio2x = (typeof window.matchMedia === 'function' && window.matchMedia('(-webkit-min-device-pixel-ratio: 1.5), (min-resolution: 1.5dppx)').matches);

  let bannerDesktop = '';
  let bannerMobile = '';

  if (devicePixelRatio2x) {
    bannerDesktop = retinaImage.desktop;
    bannerMobile = retinaImage.mobile;
  } else {
    bannerDesktop = image.desktop;
    bannerMobile = image.mobile;
  }
  const bannerBgImage = `url(${baseRequestUrl}ShopSmall/bannerImages/${bannerDesktop})`;
  const bannerCopy = bannerConfig[eventTiming];

  const {
    intro: introValue,
    header: headingValue,
    copy: contentValue,
  } = bannerCopy;

  const sanitizedIntroValue = sanitizeString(introValue);
  const sanitizedHeadingValue = sanitizeString(headingValue);
  const sanitizedContentValue = sanitizeString(contentValue);
  const sanitizedPhotoCredit = sanitizeString(photoCredit);

  const contentDisplay = () => (
    <>
      <img
        className="AmexShopSmallBanner__content--logo"
        src={`${baseRequestUrl}ShopSmall/bannerImages/${logo}`}
        alt="Amex & Shop Small logo"
      />
      <h1>
        <span
          className="AmexShopSmallBanner__content--intro"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: sanitizedIntroValue,
          }}
        />
        <span
          className="AmexShopSmallBanner__content--title"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: sanitizedHeadingValue,
          }}
        />
      </h1>
      <p
        className="AmexShopSmallBanner__content--text"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: sanitizedContentValue,
        }}
      />
      <p
        className="AmexShopSmallBanner__content--credit"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: sanitizedPhotoCredit,
        }}
      />
    </>
  );

  return (
    <section className="AmexShopSmallBanner">
      <div className="AmexShopSmallBanner__wrapper">
        <div
          className="AmexShopSmallBanner__image"
          style={{ backgroundImage: bannerBgImage }}
        />
        <div className="container">
          <div className="AmexShopSmallBanner__content">
            {contentDisplay()}
          </div>
        </div>
        {!matchMedia.md && (
          <img
            className="AmexShopSmallBanner__image-mobile"
            src={`${baseRequestUrl}ShopSmall/bannerImages/${bannerMobile}`}
            alt=""
          />
        )}
      </div>
    </section>
  );
};

AmexShopSmallBanner.propTypes = {
  baseRequestUrl: PropTypes.string.isRequired,
  bannerConfig: PropTypes.shape({
    logo: PropTypes.string.isRequired,
    retina_image: PropTypes.shape({
      desktop: PropTypes.string.isRequired,
      mobile: PropTypes.string.isRequired,
    }),
    image: PropTypes.shape({
      desktop: PropTypes.string.isRequired,
      mobile: PropTypes.string.isRequired,
    }),
    photo_credit: PropTypes.string.isRequired,
    before: PropTypes.shape({
      header: PropTypes.string.isRequired,
      copy: PropTypes.string.isRequired,
    }),
    during: PropTypes.shape({
      header: PropTypes.string.isRequired,
      copy: PropTypes.string.isRequired,
    }),
    after: PropTypes.shape({
      header: PropTypes.string.isRequired,
      copy: PropTypes.string.isRequired,
    }),
  }).isRequired,
  matchMedia: PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    xl: PropTypes.bool,
  }).isRequired,
  eventTiming: PropTypes.string.isRequired,
};

export default AmexShopSmallBanner;
